import { Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
    return (
        <footer className="border-t border-slate-100 bg-white" data-testid="footer">
            <div className="mx-auto max-w-[1320px] px-6 py-14 sm:px-10 lg:px-16">
                <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
                    <div>
                        <Logo />
                        <p className="mt-5 max-w-xs text-sm font-extralight leading-relaxed text-slate-500">
                            A whole new way to shop. Discover, style and shop fashion.
                        </p>
                    </div>
                    <nav className="flex flex-col gap-4 text-sm font-light text-slate-500 sm:flex-row sm:items-center sm:gap-8" aria-label="Footer">
                        <a
                            href="https://www.instagram.com/editfashionapp"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="footer-link flex w-max items-center gap-2 hover:text-slate-950"
                            data-testid="footer-instagram-link"
                        >
                            <Instagram size={16} strokeWidth={1.5} />
                            Instagram
                        </a>
                        <a
                            href="mailto:editvirtualstylist@gmail.com"
                            className="footer-link w-max hover:text-slate-950"
                            data-testid="footer-contact-link"
                        >
                            Contact
                        </a>
                        <Link to="/privacy" className="footer-link w-max hover:text-slate-950" data-testid="footer-privacy-link">
                            Privacy Policy
                        </Link>
                        <Link to="/terms" className="footer-link w-max hover:text-slate-950" data-testid="footer-terms-link">
                            Terms &amp; Conditions
                        </Link>
                    </nav>
                </div>
                <div className="mt-12 flex flex-col gap-2 border-t border-slate-100 pt-6 text-xs font-extralight text-slate-400 sm:flex-row sm:justify-between">
                    <p data-testid="footer-copyright">© EDIT Technologies Limited</p>
                    <p>Fashion discovery &amp; shopping.</p>
                </div>
            </div>
        </footer>
    );
}
